import { StickyButton } from "./StickyButton";
// @ts-ignore
import styled from "styled-components/macro";

interface CrossroadsProps {
  goText: string;
  noText: string;
  goOnClick: () => void;
  noOnClick: () => void;
}

export default function Crossroads({ goText = "Continue", noText = "Later", goOnClick, noOnClick }: CrossroadsProps) {
  return (
    <CrossroadsContainer>
      <StickyButton text={noText} variant="no-button" onClick={noOnClick} />
      <StickyButton text={goText} variant="go-button" onClick={goOnClick} />
    </CrossroadsContainer>
  );
}

const CrossroadsContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  left: -22%;
  bottom: 0px;

  > * {
    position: relative;
    margin-top: -10px;
  }

  > :nth-child(2) {
    left: 60%;

    &:hover {
      left: 65%;
    }
  }
`;
